import type { TemplateAssignmentScope } from '@Application/Documents/TemplateAssignments/TemplateAssignmentScope';

// One entry per non-archived document type of the account, in the server's order (system types
// first, then free types by label), including document types with no assignment at all.
// `documentType`, `template`, `inheritedTemplate` and `appliedTemplate` are relations, always
// `{ id }` or `null` — never nested further: the label is resolved client-side via
// `DocumentTypesListView.labelOf`. `inheritedTemplate` is always `null` at the organization level:
// only a facility scope can inherit from above.
export type TemplateAssignmentEntryPayload = {
	readonly documentType: { readonly id: number };
	readonly template: { readonly id: number } | null;
	readonly inheritedTemplate: { readonly id: number } | null;
	readonly appliedTemplate: { readonly id: number } | null;
};

export type TemplateAssignmentsFetchedPayload = TemplateAssignmentEntryPayload[];

export type TemplateAssignmentsFetchedAction = {
	type: 'TEMPLATE_ASSIGNMENTS_FETCHED';
	payload: TemplateAssignmentsFetchedPayload;
	scope: TemplateAssignmentScope;
};

export default (
	payload: TemplateAssignmentsFetchedPayload,
	scope: TemplateAssignmentScope,
): TemplateAssignmentsFetchedAction => ({
	type: 'TEMPLATE_ASSIGNMENTS_FETCHED',
	payload,
	scope,
});
